import keys from 'lodash.keys';
// import values from 'lodash.values';
// import i18nMessages from './../i18n/messages';
import getValidators from '../functions/validators';

const validators = getValidators('pt-BR');
const openingTimesValidation = currentValues => {
  const productIds = keys(currentValues);

  for (let i = 0; i < productIds.length; i += 1) {
    const cylinderPriceError = validators.cylinderPrice(currentValues[productIds[i]].price);

    if (cylinderPriceError) {
      return {
        _error: cylinderPriceError,
      };
    }
  }

  return {};
};

export default openingTimesValidation;



// WEBPACK FOOTER //
// ../utils/form-validations/manage-products-validation.js